import { Crumbs } from "molecules/Breadcrumbs";
import { TitleHeading } from "molecules/TitleHeading";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { ListBox } from "primereact/listbox";
import { Timeline } from "primereact/timeline";
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { MultiSelect } from "primereact/multiselect";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { useNavigate } from "react-router-dom";
import DropdownTable from "component/DropdownTable/DropdownTable";
import { SmallHadding } from "molecules/SmallHeadding";
import Modal from "react-modal";
import { SectionBorder } from "molecules/SectionBorder";
import Divider from "molecules/SimpleBorder/Divider";
import { useSelector } from "react-redux";

const CustDropdown = styled(MultiSelect)`
  border: 1px solid rgb(200, 32, 39);
  background: transparent;
  border-radius: 0;
  font-weight: 500;
  cursor: pointer;
`;

function stripHtml(value) {
  if (value == null) return "";
  return String(value).replace(/<[^>]*>/g, " ");
}

function normalizeField(value) {
  if (value == null) return "";
  const s = String(value).trim();
  if (s.toLowerCase() === "null" || s.toLowerCase() === "undefined") return "";
  return s;
}

function rowsToDropdownOptions(rows, getValue) {
  const seen = new Set();
  const names = [];
  (rows || []).forEach((row) => {
    const raw = normalizeField(getValue(row));
    if (raw !== "" && !seen.has(raw)) {
      seen.add(raw);
      names.push(raw);
    }
  });
  return names.sort((a, b) => a.localeCompare(b)).map((name, idx) => ({ name, code: `${idx}` }));
}

function jobMatchesSearch(job, rawQuery) {
  const needle = normalizeField(rawQuery).toLowerCase();
  if (needle === "") return true;
  const blobs = [
    job?.title,
    job?.location,
    job?.designation,
    job?.job_type,
    job?.role_name,
    stripHtml(job?.the_role),
    stripHtml(job?.position_overview),
    stripHtml(job?.primary_responsibilities),
  ];
  const hay = blobs.filter(Boolean).join(" ").toLowerCase();
  return hay.includes(needle);
}

function jobPassesMultiFilters(job, selected) {
  const designation = normalizeField(job?.designation);
  const jobType = normalizeField(job?.job_type);
  const location = normalizeField(job?.location);
  const payRange = normalizeField(job?.pay_range);

  if (selected.designation.length && !selected.designation.includes(designation))
    return false;
  if (selected.jobType.length && !selected.jobType.includes(jobType)) return false;
  if (selected.location.length && !selected.location.includes(location)) return false;
  if (selected.payRange.length && !selected.payRange.includes(payRange))
    return false;
  return true;
}

const Careers = () => {

  
  const { data: ourServiceData, loading: loadingourService, error: errorourService } = useSelector((state) => state.jobData);
  const { data: dashboardData } = useSelector((state) => state.dashboard);
  
  // console.log(ourServiceData,"aasa")



  const [modalIsOpen, setModalIsOpen] = useState(false);
  const openModal = () => {
    setModalIsOpen(true);
  };
  const customStylesForMobile = {
    content: {

      position: 'absolute',
      top: 150,
      right: 0
      ,      // right: "100%",
      // right: "auto",
      bottom: 0,
      paddingTop: 0,
      marginTop: 0,
      // transform: "translate(-50%, -50%)",
      width: "100%",
      maxWidth: "250px",
      maxHeight: '100vh',
      overflowY: 'auto',
      border: 'none !importent', // Remove the default border


      // backgroundColor: 'red'

      // backgroundColor: 'red'
    },
  };

  const customStyles = {
    content: {
      top: '50%', // Center it vertically
      right: '0', // Align to the right
      left: 'auto', // Remove any left offset
      bottom: '0', // Make it stretch to the bottom if needed
      transform: 'translateY(-50%)', // Center it vertically
      width: '40%', // Adjust the width, you can change this percentage based on your needs
      maxWidth: '1000px', // Ensures that it doesn’t go over a certain width
      height: '100vh', // Full height
      padding: '20px', // Adjust padding if necessary
      backgroundColor: '#fff', // Ensure it has a proper background color
      overflowY: 'auto', // Allow scrolling if content overflows
      zIndex: 999, // Ensure it’s always on top
    },
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };
  const navigate = useNavigate();

  /** Full list from API; filters apply on top of this copy */
  const [jobs, setJobs] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterDesignation, setFilterDesignation] = useState([]);
  const [filterJobType, setFilterJobType] = useState([]);
  const [filterLocation, setFilterLocation] = useState([]);
  const [filterPayRange, setFilterPayRange] = useState([]);
  const [showFullDesc, setShowFullDesc] = useState(false);

  useEffect(() => {
    if (Array.isArray(ourServiceData)) {
      setJobs(ourServiceData);
    } else {
      setJobs([]);
    }
  }, [ourServiceData]);

  const filterOptions = useMemo(() => {
    const rows = Array.isArray(jobs) ? jobs : [];
    return {
      designation: rowsToDropdownOptions(rows, (j) => j?.designation),
      jobType: rowsToDropdownOptions(rows, (j) => j?.job_type),
      location: rowsToDropdownOptions(rows, (j) => j?.location),
      payRange: rowsToDropdownOptions(rows, (j) => j?.pay_range),
    };
  }, [jobs]);

  const filteredJobs = useMemo(() => {
    const rows = Array.isArray(jobs) ? jobs : [];
    const selected = {
      designation: filterDesignation ?? [],
      jobType: filterJobType ?? [],
      location: filterLocation ?? [],
      payRange: filterPayRange ?? [],
    };
    return rows.filter(
      (job) =>
        jobMatchesSearch(job, searchQuery) && jobPassesMultiFilters(job, selected)
    );
  }, [jobs, searchQuery, filterDesignation, filterJobType, filterLocation, filterPayRange]);

  const renderFilterDropdowns = ({ className = "", vertical = false }) => (
    <div
      className={className}
      style={{
        display: "flex",
        flexDirection: vertical ? "column" : "row",
        alignItems: vertical ? "stretch" : "center",
        justifyContent: "flex-start",
        gap: "20px",
        flexWrap: vertical ? "nowrap" : "wrap",
      }}
    >
      {/* strategies = office/location buckets; Job Category = role designation */}
      <DropdownTable title="Locations" options={filterOptions.location} value={filterLocation} onChange={setFilterLocation} />
      <DropdownTable title="Time Type" options={filterOptions.jobType} value={filterJobType} onChange={setFilterJobType} />
      <DropdownTable title="Job Category" options={filterOptions.designation} value={filterDesignation} onChange={setFilterDesignation} />
      {/* <DropdownTable title="More" options={filterOptions.payRange} value={filterPayRange} onChange={setFilterPayRange} /> */}
    </div>
  );

  return (
    <div className="backgroundThm "
    >
      <section>
        <div className="container">
          <Crumbs />

          <div className="grid flex-column section-title mt-0">

            <div className="lg:col-4 md:col-3 sm:col-12">
              {/* <SmallHadding
            text="Job Search"
            className="mt-2 mb-2 ef-gamon-font" 
            
            
          /> */}
              <h3 className="pageTitle pb-2 mt-1" >Job Search</h3>

              {/* <TitleHeading title="Job Search" className="mt-0 mb-2" /> */}
            </div>
          </div>
          <div
            className="mb-1 border-top-1 border-bottom-1 py-0"
            style={{ borderColor: "black" }}
          >
            <div className="grid mt-2">
              <div
                className="lg:col-9 md:col-9 sm:col-12"
                style={{ backgroundColor: "white", height: "55px" }}
              >
                <IconField iconPosition="left">
                  <InputIcon className="pi pi-search"> </InputIcon>
                  <InputText
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") e.preventDefault();
                    }}
                    placeholder="Search for jobs or keywords"
                    className="w-full border-noround pl-6 border-none"
                    aria-label="Search jobs"
                  />
                </IconField>
              </div>
              <div className="lg:col-3 md:col-3 sm:col-12">
                {/* <button
                  className="btn w-full "
                  style={{
                    backgroundColor: "#C82027",
                    width: "10px !important",
                    color: "white",
                  }}
                >
                  SEARCH
                </button> */}
                <div className="JobSearchBtn">
                  <span style={{ color: "white" }}>SEARCH</span>
                </div>
              </div>
            </div>


            <div className="mb-3 mt-2">

              <div className="pl-0 pb-3 pt-3" style={{ display: "flex", flexDirection: "row", alignItems: 'center', justifyContent: 'space-between' }}>
                <div className="lg:col-3 md:col-6 sm:col-12 pl-0 hideInMobile">
                  <div
                    className="flex align-items-center"
                    style={{
                      borderBottom: "2px solid rgb(200, 32, 39)",
                      width: "100px",
                      paddingLeft: "1rem",
                    }}
                  >
                    <i className="pi pi-sliders-h mr-2"></i>
                    <span className="text-lg s-25">Filter</span>
                  </div>
                </div>
                {renderFilterDropdowns({ className: "insightDropdown" })}
              </div>
              <div className="grid align-items-center">
                <div className="container pr-0 pl-0  showInMobile">
                  <Divider />
                </div>
                <div
                  className="flex align-items-center mt-0  -mb-2 showInMobile"
                  style={{
                    // borderBottom: "2px solid rgb(200, 32, 39)",
                    width: "100px",
                    paddingLeft: "1rem",
                  }}
                >

                  <div className="showInMobile">
                    <i className="pi pi-sliders-h mr-2 "></i>
                  </div>
                  <span className="text-lg s-25 showInMobile" onClick={openModal}>Filter</span>

                </div>

                <div className="lg:col-3 md:col-6 sm:col-12">
                  {/* <CustDropdown
                    multiple={true}
                    value={selectedStrategies}
                    onChange={(e) => setSelectedStrategies(e.value)}
                    options={strategies}
                    optionLabel="name"
                    placeholder="Location"
                    className="w-full "
                    checkmark={true}
                    highlightOnSelect={false}
                    style={{
                      border: "1px solid rgb(200, 32, 39)",
                      background: "transparant",
                    }}
                  /> */}
                  {/* <DropdownTable title="Strategies" options={strategies} /> */}
                </div>

                <div className="lg:col-3 md:col-6 sm:col-12">
                  {/* <CustDropdown
                    multiple={true}
                    value={selectedStrategies}
                    onChange={(e) => setSelectedStrategies(e.value)}
                    options={strategies}
                    optionLabel="name"
                    placeholder="Time Type"
                    className="w-full "
                    checkmark={true}
                    highlightOnSelect={false}
                    style={{
                      border: "1px solid rgb(200, 32, 39)",
                      background: "transparant",
                    }}
                  /> */}
                  {/* <DropdownTable title="Time Type" options={strategies} /> */}
                </div>

                <div className="lg:col-3 md:col-6 sm:col-12">
                  {/* <CustDropdown
                    multiple={true}
                    value={selectedStrategies}
                    onChange={(e) => setSelectedStrategies(e.value)}
                    options={strategies}
                    optionLabel="name"
                    placeholder="Job Category"
                    className="w-full"
                    checkmark={true}
                    highlightOnSelect={false}
                    style={{
                      border: "1px solid rgb(200, 32, 39)",
                      background: "transparant",
                    }}
                  /> */}

                  {/* <DropdownTable title="Job Category" options={strategies} /> */}
                </div>

                <div className="lg:col-3 md:col-6 sm:col-12">
                  {/* <CustDropdown
                    multiple={true}
                    value={selectedStrategies}
                    onChange={(e) => setSelectedStrategies(e.value)}
                    options={strategies}
                    optionLabel="name"
                    placeholder="More"
                    className="w-full "
                    checkmark={true}
                    highlightOnSelect={false}
                    style={{
                      border: "1px solid rgb(200, 32, 39)",
                      background: "transparant",
                    }}
                  /> */}

                  {/* <DropdownTable title="More" options={strategies} /> */}
                </div>
              </div>
            </div>
          </div>

          <div className="grid nested-grid">
            <div className="container mb-2">
              <div className="row careerWidthContainer ">
                <div className="careerWidth pl-0 pr-0">
                  <div className="text-left pl-0 pr-3 pb-4 pt-4 mt-1 font17 font-bold text-500 borderRight1">
                  {filteredJobs.length} Jobs Found
                  </div>

                  {filteredJobs?.map(( job) => {
                      return (
                        <div
                          key={job?.id}
                          className="text-left pl-0 pr-3 pt-4 pb-4 border-1 border-left-none border-bottom-none borderRight1 font17"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            navigate(`/job-details/${job?.id}`);
                          }}
                        >
                          <p data-aos="fade-up " className="m-0 font-bold" >{job?.title}</p>
                          <div data-aos="fade-up" className="flex align-items-center text-600">
                            <i className="pi pi-map-marker mr-2"></i>
                            <span>{job?.location}</span>
                          </div>
                          <p data-aos="fade-up" className="mt-2 mb-0" style={{ color: "#0D0D0D80" }}>
                            {job?.the_role}
                            <span className="text-sm" style={{ float: "right" }}>
                            {/* {job?.start_date ? job?.start_date?.split('T')[0] : ''}  */}
                            </span>
                          </p>
                        </div>
                      );
                    })}
                </div>
                <div className="careerWidth" data-aos="fade-up"
                  data-aos-duration="1500">
                  {(() => {
                    const desc = dashboardData?.jobs_right_side_description || "Quantum";
                    const isLong = desc.length > 150;
                    const truncatedDesc = isLong ? desc.slice(0, 150) + "..." : desc;

                    return (
                      <div className="text-center py-4 h-full">
                        <p className="font17">{dashboardData?.jobs_right_side_top_title || "Grow your Career at Quantum"}</p>
                        <p
                          style={{ color: "#C82027", fontFamily: "EB Garamond" }}
                          className="my-5 uppercase text-5xl"
                        >
                          {dashboardData?.jobs_right_side_mid_text || "Quantum"}
                        </p>
                        <p
                          className="justify-content-center font17 px5rem lg:w-9 md:w-9 sm:w-full m-auto line-height-3"
                          style={{ color: "#1E1E1E" }}
                        >
                          {isLong
                            ? (showFullDesc ? desc : truncatedDesc)
                            : desc}
                        </p>
                        {isLong && (
                          <Button
                            outlined
                            className="py-1 px-3 text-xs mt-3 border-700 bg-white text-600"
                            onClick={() => setShowFullDesc((prev) => !prev)}
                          >
                            {showFullDesc ? 'Show Less' : 'Read More'}
                          </Button>
                        )}
                      </div>
                    );
                  })()}
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStylesForMobile}
          contentLabel="Project Detail Modal"
          className=" mobileHistoryDiv"
        >
          <div className="col-12 " >

            <div className="before-red-border1 "
              style={{
                position: "relative",
                top: "100px",
                zIndex: "9",
                display: 'flex',
                flexDirection: 'column',
                gap: '20px',
                width: '100%'

              }}

            >

              <div className="">
                <SectionBorder />
                <div
                  className="flex align-items-center py-0  my-2"
                  style={{
                    // borderBottom: "2px solid rgb(200, 32, 39)",
                    width: "100px",
                    paddingLeft: "1rem",
                  }}
                >
                  <i className="pi pi-sliders-h mr-2 "></i>
                  <span className="text-lg s-25" onClick={openModal}>Filter</span>
                </div>
                <SectionBorder />
              </div>

              {renderFilterDropdowns({ vertical: true })}



            </div>
          </div>
        </Modal>
      </section>
    </div>
  );
};

export default Careers;
